"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Child = _interopRequireDefault(require("./Child"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Menu/Item.js";
var defaultIcon = "bi bi-journal-text";
var defaultProps = {
  onClick: function onClick() {}
};
function Item(_ref) {
  var menu = _ref.menu,
    _onClick = _ref.onClick;
  var name = menu.name,
    icon = menu.icon,
    label = menu.label,
    disabled = menu.disabled;
  var route = menu.route || '/' + name;
  if (Array.isArray(route)) {
    return /*#__PURE__*/_react["default"].createElement(_Child["default"], {
      menu: menu,
      onClick: _onClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 16
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "nav-item",
    key: route,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick(e) {
      return _onClick(e, menu);
    },
    href: route,
    className: (0, _classNames["default"])("nav-link text-truncate", disabled ? 'disabled' : ''),
    to: route,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon || defaultIcon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 17
    }
  }, label || name)));
}
Item.defaultProps = defaultProps;
var _default = exports["default"] = Item;